import { CurrentLanguageSelected } from '../utility/current-language-selected';

export function currentLanguage(language: CurrentLanguageSelected) {
  return language.getCurrentLanguage();
}
